import { Component } from '@verndale/core';
import Dropdown from '../../components/dropdown';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      dropdown: this.el.querySelector('.mobile_tab_dropdown')
    };

    this.dropdown = new Dropdown(this.dom.dropdown);
  }

  addListeners() {
    this.dropdown.on('option', this.handleOptionChange.bind(this));
  }

  handleOptionChange(e) {
    window.location.href = e.target.value;
  }
}

export default Module;
